const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        impressum: 'Impressum',
        disclaimer: 'Datenschutzerklärung',
        videoCallDisclaimerText:
            'Sie möchten unser telemedizinisches Angebot nutzen.\n\n' +
            'Wir weisen Sie darauf hin, dass wir dieses Angebot mit Teams von Microsoft durchführen.\n\n' +
            'Ihre Kommunikations-Daten werden im gleichen technischen und organisatorischen Umfang wie alle Teams ' +
            'Einzelgespräche geschützt und sind End to End verschlüsselt. Es gelten die Datenschutzbestimmungen der ' +
            'geographischen Region die Ihrer Microsoft 365 oder Office 365-Organisation zugeordnet ist.\n\n' +
            'Nutzen Sie unsere telemedizinische Dienstleistung innerhalb der Schweiz, werden Ihre Login Teamsdaten ' +
            'in der Schweiz gespeichert.\n\n' +
            'Die Kommunikations-Daten während Ihrer telemedizinischen Sitzung werden weder aufgezeichnet noch ' +
            'gespeichert.\n\n' +
            'Sie dürfen Ihre Sitzung ohne die Einwilligung der beratenden Person ebenfalls nicht aufzeichnen.\n\n' +
            'Mit der Nutzung dieses Angebotes geben Sie die Einwilligung, dass Sie mit der Übermittlungsform via ' +
            'Microsoft Teams einverstanden sind.',
        bookAppointmentInfoText: '',
        welcomeText: 'Patientenportal Meine soH - Ihr digitaler Begleiter rund um den Spitalaufenthalt',
    },
    __RELATIVE_SOURCE_FILE__
);
